<template>
    <div id="banner-section">
        <b-modal size="lg" @hide="onHide" id="sidebar-modal" ref="sidebarModal" centered hide-header hide-footer>
            <div class="container">
                <div class="row">
                    <div class="col-12">
                        <div class="banner mx-auto d-flex flex-column">
                            <button class="close-icon" id="modal-close" @click="$bvModal.hide('sidebar-modal')">
                                <Icon icon="close-modal"/>
                            </button>
                            <div class="banner-content">
                                <div class="d-flex justify-content-center">
                                    <Icon icon="sidebar-modal-icon"/>
                                </div>
                                <div class="mt-5">
                                    <p class="h4b c7 text-center" style="line-height: 32px">Let campaigns know you CrossPromote</p>
                                </div>
                                <div class="mt-4">
                                    <p class="text-center c23 p1n mb-0">Download this banner and post it on your Kickstarter page along with the</p>
                                    <p class="text-center c23 p1n">link below to let campaigners easily find you on Crossprom.</p>
                                </div>
                            </div>
                            <div class="banner-wrap">
                                <div class="d-flex justify-content-center position-relative">
                                    <div class="download-icon position-absolute">
                                        <DownloadImgIcon @click.native="download(bannerSrc)"/>
                                    </div>
                                    <img :src="bannerSrc" alt="">
                                </div>
                                <div class="link-input d-flex justify-content-center">
                                    <input 
                                        type="text" 
                                        class="w-100"
                                        disabled 
                                        :value="lastCampaignUrl">
                                    <a-tooltip>
                                        <template v-if="copied" slot="title">
                                            Copied
                                        </template>
                                        <template v-else slot="title">
                                            Copy
                                        </template>
                                        <button class="p-0">
                                            <CopyIcon type="banner" @click.native="copyTextToClipboard(lastCampaignUrl)"/>
                                        </button>
                                    </a-tooltip>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </b-modal>
    </div>
</template>

<script>
import { ref } from '@vue/composition-api'
import Button from '../components/Theme/Button'
import Icon from '../components/Theme/Icon'
import useSidebarModal from './useSidebarModal'
import { CampSuccessIcon, CopyIcon, DownloadImgIcon } from '../components/Icons' 
export default {
    name: 'SidebarModal',
    components: {
        CampSuccessIcon,
        DownloadImgIcon,
        CopyIcon,
        Button,
        Icon
    },
    setup: function(props,context) {
        const { lastCampaignUrl } = useSidebarModal()
        let copied = ref(false)
        const bannerSrc = ref('https://firebasestorage.googleapis.com/v0/b/crossprom-staging.appspot.com/o/img%2Fbanner.jpg?alt=media&token=d23dfc03-3e2c-4775-be70-7e1df69d7d52')

        const onHide = () => {
            context.root.$emit('bv::show::modal', 'sidebar-modal')
        }
        const copyTextToClipboard = (text) => {
            let el = document.createElement('input')  
            el.value = text
            document.body.appendChild(el)
            el.select()
            el.focus()
            document.execCommand('copy')
            document.body.removeChild(el)  
            copied.value = true  
            setTimeout(() => {
                copied.value = false 
            }, 2000)

            context.root.$ga.event('Banner Modal', 'Copy Link', 'Location', 'Dashboard');
            context.root.$sendMixpanelEvent('Banner Modal Copy Link Clicked', {
                'Banner Location': 'Dashboard'
            });

        }
        const download = (url) => {
            fetch(url)
                .then(response => response.blob())
                .then(blob => {
                    const image = URL.createObjectURL(blob)
                    const link = document.createElement('a')
                    link.href = image
                    link.download = 'crossprom-banner.jpg'
                    document.body.appendChild(link)
                    link.click()
                    document.body.removeChild(link)
                })

            context.root.$ga.event('Banner Modal', 'Download Pic', 'Location', 'Dashboard');
            context.root.$sendMixpanelEvent('Banner Modal Download Clicked', {
                'Banner Location': 'Dashboard'
            });
        }
        return {
            lastCampaignUrl,
            copied,
            bannerSrc,
            onHide,
            copyTextToClipboard,
            download
        }
    },
}
</script>

<style scoped lang="scss">
div.banner {
    width: 100%;
    height: 600px;
    background: #FFFFFF;
    border-radius: 5px;
    position: relative;

    button.close-icon {
        position: absolute;
        top: 8px;
        right: 8px;
        padding: 0;
    }

    div.banner-content {
        // width: 540px;
        margin: 0 auto;
        padding-top: 60px;
        padding-left: 56px;
        padding-right: 56px;
    }

    div.banner-wrap {
        height: 248px;
        background: #F4F4F4;
        padding-left: 54px;
        padding-right: 54px;
        padding-top: 32px;
        flex-grow: 1;
        border-bottom-left-radius: 5px;
        border-bottom-right-radius: 5px;
        
        div.download-icon {
            right: 8px;
            top: 8px;
        }
        div.link-input {
            padding-top: 32px;
            input {
                width: 430px;
                height: 33px;
                padding-left: 10px;
                background: #FFFFFF;
                border: 1px solid #727CF5;
                border-top-left-radius: 5px;
                border-bottom-left-radius: 5px;
                font-size: 12px;
                color: #333333;
            }
        }

    }
    div.banner-footer {
        button {
            padding: 12px 102px;
            font-size: 13px !important;
            font-weight: bold !important;
        }
    }
}
</style>